import icon from "../../assets/hammer.svg";
import type { Property } from "../../types";

export const wifiMounting: Property = {
  id: "wifiMounting",
  title: "wifiMounting.title",
  icon,
};
